import React from 'react';
export function FeaturesSection() {
  const features = [{
    num: '01',
    title: 'Fundamentos de la Influencia',
    desc: 'Cómo funciona el cerebro social y por qué respondemos de maneras predecibles ante ciertos estímulos.'
  }, {
    num: '02',
    title: 'Lenguaje Corporal y Microexpresiones',
    desc: 'Lee lo que nadie dice en voz alta. Detecta emociones reales detrás de palabras calculadas.'
  }, {
    num: '03',
    title: 'Persuasión Narrativa',
    desc: 'Las historias que mueven decisiones. Estructuras de comunicación que generan acción sin resistencia.'
  }, {
    num: '04',
    title: 'Detección de Manipuladores',
    desc: 'Identifica patrones tóxicos: narcisismo, gaslighting, DARVO — y cómo neutralizarlos.'
  }, {
    num: '05',
    title: 'Liderazgo e Influencia Ética',
    desc: 'Ejerce autoridad auténtica. Guía sin imponer. Genera lealtad sin dependencia.'
  }, {
    num: '06',
    title: 'Relaciones y Dinámicas de Poder',
    desc: 'Construye vínculos genuinos sabiendo cuándo los límites están siendo cruzados.'
  }];
  return <section className="py-14 md:py-20 bg-negro-medio" data-id="element-118">
      <div className="container" data-id="element-119">
        <div className="text-center max-w-[680px] mx-auto mb-8 md:mb-10" data-id="element-120">
          <div className="section-label justify-center" data-id="element-121">El sistema</div>
          <h2 className="font-playfair text-[clamp(1.7rem,3.5vw,2.7rem)] font-bold leading-[1.2] text-blanco text-center" data-id="element-122">
            Lo que aprenderás en
            <br data-id="element-123" />
            <em className="text-dorado-claro not-italic italic" data-id="element-124">
              Código Oscuro
            </em>
          </h2>
          <p className="text-gris-texto mt-3.5 text-[.91rem] leading-[1.7]" data-id="element-125">
            12 capítulos construidos sobre evidencia real. Cada técnica viene
            con teoría, ejemplos concretos y ejercicios de aplicación inmediata.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-0.5 max-md:grid-cols-2 max-sm:grid-cols-1" data-id="element-126">
          {features.map((f, i) => <div key={i} className="bg-negro-suave p-[30px_22px] transition-colors duration-300 relative group hover:bg-[rgba(201,151,43,.06)]" data-id="element-127">
              <div className="absolute top-0 left-0 right-0 h-[2px] bg-[linear-gradient(90deg,transparent,var(--dorado),transparent)] opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-128" />
              <div className="font-playfair text-[2.6rem] font-black text-[rgba(201,151,43,.15)] leading-none mb-2.5" data-id="element-129">
                {f.num}
              </div>
              <h3 className="font-playfair text-[1.05rem] text-blanco mb-2.5" data-id="element-130">
                {f.title}
              </h3>
              <p className="text-[.87rem] text-gris-texto leading-[1.7]" data-id="element-131">
                {f.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}